// PORTABLE LOGIC — no view/DOM deps. Maps an NWS forecast/condition string to a
// stable, platform-agnostic icon *key*. The web app binds keys → lucide-react in
// src/components/WeatherGlyph.tsx; the future RN port binds the same keys →
// lucide-react-native. NWS is deprecating its rendered icon URLs, so we classify
// from the condition text and keep one consistent icon family per platform.

export type WeatherIconKey =
  | 'tornado'
  | 'thunderstorm'
  | 'hail'
  | 'snow'
  | 'drizzle'
  | 'rain'
  | 'fog'
  | 'wind'
  | 'cloudy'
  | 'partly-day'
  | 'partly-night'
  | 'clear-day'
  | 'clear-night'

export function weatherIcon(text: string, isDaytime = true): WeatherIconKey {
  const t = text.toLowerCase()

  if (/tornado/.test(t)) return 'tornado'
  if (/thunder|lightning|t-storm|tstorm/.test(t)) return 'thunderstorm'
  if (/hail|sleet|ice|freezing/.test(t)) return 'hail'
  if (/snow|flurr|blizzard|wintry/.test(t)) return 'snow'
  if (/drizzle/.test(t)) return 'drizzle'
  if (/rain|shower|precip/.test(t)) return 'rain'
  if (/fog|haze|mist|smoke/.test(t)) return 'fog'
  if (/wind|breezy|gust/.test(t)) return 'wind'
  if (/overcast|cloudy/.test(t)) return 'cloudy'
  if (/partly|mostly sunny|few clouds|mostly clear/.test(t)) return isDaytime ? 'partly-day' : 'partly-night'
  if (/sunny|clear|fair|hot/.test(t)) return isDaytime ? 'clear-day' : 'clear-night'

  return isDaytime ? 'partly-day' : 'partly-night'
}
